import { cn } from '@/utils/cn';
import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
  to: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
  state?: Record<string, unknown>;
}

export const Link = ({
  to,
  className = '',
  onClick,
  children,
  state,
}: LinkProps) => {
  return (
    <RouterLink
      to={to}
      onClick={onClick}
      className={cn(`text-secondary underline ${className}`)}
      state={state}
    >
      {children}
    </RouterLink>
  );
};
